// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AboutUs from '../components/Frontend/Pages/AboutUs';
import About from '../components/Frontend/Pages/About';
import PrivacyPolicy from '../components/Frontend/Pages/PrivacyPolicy';
import Accessibility from '../components/Frontend/Pages/Accessibility';
import Disclaimer from '../components/Frontend/Pages/Disclaimer';
import HelpAccountIQ from '../components/Frontend/Pages/HelpAccountIQ';
import AskQuestion from '../components/Frontend/Pages/AskQuestion';
import Unsubscribe from '../components/Frontend/Pages/Unsubscribe';
import Newsresponse from '../components/Frontend/Pages/Newsresponse';
// import TermsofUse from '../components/Frontend/Pages/TermsofUse';
import Help from '../components/Frontend/Pages/Help';
import TermsofUseNew from '../components/Frontend/Pages/TermsOfUseNew';

export const frontendRoutes = (
  <>
    <Route path="/pages" element={<MainLayout />}>
      <Route path="aboutus" element={<AboutUs />} />
      <Route path="about_us" element={<About />} />
      <Route path="privacy_policy" element={<PrivacyPolicy />} />
      <Route path="accessibility" element={<Accessibility />} />
      <Route path="disclaimer" element={<Disclaimer />} />
      <Route path="help_account_iq" element={<HelpAccountIQ />} />
      <Route path="askquestion" element={<AskQuestion />} />
      <Route path="unsubscribe" element={<Unsubscribe />} />
      <Route path="newsresponse" element={<Newsresponse />} />
      <Route path="terms_of_use" element={<TermsofUseNew />} />
      <Route path="help" element={<Help />} />
    </Route>
  </>
);
